import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Src/constants/Urls'
import {
	RbidosLeadModel,
	STATUSES_FOR_REQUEST_LEAD,
	RbidosLeadCreateModel,
	AFTER_SBER_ID_USER_INFO,
	ParamsMassUpdateLead,
} from 'Pages/lead'
import { ELECTRONIC_CONSENT_STATUS } from 'Pages/orders_design'
import { serialize } from 'object-to-formdata'

export const leadApi = {
	getAll: async (requestParams: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<RbidosLeadModel>>(urls.rbidos_lead.index, {
			params: requestParams,
		})
		return res.data
	},

	getOne: async (id: number) => {
		const res = await axiosDS().get(`${urls.rbidos_lead.index}/${id}`)
		return res.data
	},

	downloadFile: async (id: number, file_type: string) => {
		const res = await axiosDS().get<Blob>(
			urls.rbidos_lead.notary_file.replace(':id', id.toString()).replace(':file_type', file_type),
			{ responseType: 'blob' }
		)
		return res.data
	},

	getTotalConsentWait: async () => {
		const res = await axiosDS().get<ResponseCatalog<RbidosLeadModel>>(urls.rbidos_lead.index, {
			params: {
				state: STATUSES_FOR_REQUEST_LEAD.CONSENT_WAIT.join(),
			},
		})
		return res.data
	},

	getTotalNoOrders: async () => {
		const res = await axiosDS().get<ResponseCatalog<RbidosLeadModel>>(urls.rbidos_lead.index, {
			params: {
				state: ELECTRONIC_CONSENT_STATUS.COMPLETED,
				has_order: false,
			},
		})
		return res.data
	},

	sendReport: async (params?: RequestParams) => {
		const res = await axiosDS().get<SimpleResponse>(urls.rbidos_lead.reports, {
			params: {
				...params,
			},
		})
		return res.data
	},

	createOne: async (data: RbidosLeadCreateModel) => {
		const res = await axiosDS().post(urls.rbidos_lead.index, { data })
		return res.data
	},

	refreshSmsRbidosLead: async (token: number) => {
		const res = await axiosDS().post(`${urls.rbidos_lead.refresh_sms}/${token}`)
		return res.data
	},

	getAfterSberIdUserInfo: async (id: number) => {
		const res = await axiosDS().get<AFTER_SBER_ID_USER_INFO>(
			urls.rbidos_lead.user_info_after_sber_id.replace(':id', id.toString())
		)
		return res.data
	},

	massUpdateLeadsIds: async (params: ParamsMassUpdateLead) => {
		const res = await axiosDS().patch(urls.rbidos_lead.mass_update, { ...params })
		return res.data
	},

	massUpdateLeadsFile: async (data: { file: File }) => {
		const res = await axiosDS().post(
			urls.rbidos_lead.mass_update_file,
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
}
